import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { rejectedListHeaders } from '../../constants';

import useRejectedList from './hooks';
import styles from './RejectedList.module.scss';

const RejectedList = ({ rejectedReports, loading }) => {
  const { handleRowClick, activeRow, handleColumnClick, sortByColumn, sortDirection } =
    useRejectedList();

  return (
    <div className={styles.gridContainer}>
      <DataGrid
        headers={rejectedListHeaders}
        rows={rejectedReports}
        fullWidth
        loading={loading}
        onRowClick={handleRowClick}
        selectedRow={activeRow}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
};

RejectedList.propTypes = {
  rejectedReports: PropTypes.arrayOf(
    PropTypes.shape({
      referenceNumber: PropTypes.string,
      partnerID: PropTypes.string,
      agencyID: PropTypes.string,
      firstReceivedOn: PropTypes.string,
      lastReceivedOn: PropTypes.string,
      count: PropTypes.number,
      errorMessage: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};

RejectedList.defaultProps = {
  rejectedReports: [],
  loading: true,
};

export default RejectedList;
